export default "__VITE_ASSET__KBddP9t9__"